import { QueryClient } from 'react-query';

const queryClient = new QueryClient({
  refetchOnWindowFocus: false,
});

export default queryClient;
